import * as yup from 'yup'
import moment from 'moment'

export const ticketSchema = yup.object().shape({
    flightNo: yup.mixed()
        .transform((value) => (value && value.value ? value.value : value))
        .required('Flight number is required')
        .test('valid-flight', 'Please select a valid flight', (value) => {
            return typeof value === 'string' && value.length > 0
        }),

    departureDate: yup.string()
        .required('Departure date is required')
        .test('future-date', 'Departure date must be in the future', (value) => {
            if (!value) return true
            return moment(value).startOf('day').isSameOrAfter(moment().startOf('day'))
        }),

    departureTime: yup.string()
        .required('Departure time is required')
        .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Invalid time format'),

    arrivalTime: yup.string()
        .required('Arrival time is required')
        .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Invalid time format')
        .test('valid-arrival-time', 'Arrival time must be after departure time',
            function (value) {
                const { departureTime } = this.parent
                const isNextDay = this.options.context?.isNextDay

                if (!value || !departureTime) return true

                const dTime = moment(departureTime, 'HH:mm')
                const aTime = moment(value, 'HH:mm')

                if (isNextDay) {
                    return true // If it's next day, any time is valid
                }

                return aTime.isAfter(dTime)
            }
        ),

    availableTickets: yup.number()
        .required('Available tickets is required')
        .integer('Must be a whole number')
        .min(0, 'Cannot be negative'),

    price: yup.number()
        .required('Price is required')
        .min(0, 'Price must be greater than 0')
        .test('two-decimal-places', 'Price can only have up to 2 decimal places', (value) => {
            if (!value) return true
            return /^\d+(\.\d{0,2})?$/.test(value.toString())
        })
}) 